import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {ShortToLongUrlData} from './EndUserSlice/EndUserSlice'
import {ensureHttpProtocol} from '../../../Utils/_helpers'

const ShortToLongUrl = () => {
  const dispatch = useDispatch()
  const param = useLocation()

  const getDataAfterHyphen = (inputString: string): string => {
    // Find the index of the first hyphen
    const hyphenIndex: number = inputString.indexOf('-')

    // Check if a hyphen is found
    if (hyphenIndex !== -1) {
      // Return the substring after the hyphen
      return inputString.slice(hyphenIndex + 1)
    } else {
      // Return the original string if no hyphen is found
      return inputString
    }
  }

  useEffect(() => {
    // dispatch(ShortToLongUrlData(param?.pathname?.split('-')?.at(-1))))
    dispatch(ShortToLongUrlData(getDataAfterHyphen(param?.pathname)))?.then((res: any) => {
      window.location.replace(ensureHttpProtocol(res?.payload?.data))
    })
  }, [])

  return <></>
}

export default ShortToLongUrl
